import React, { useEffect, useState } from "react";
import { pubCall } from "../utils/PubSub";
import { showError, showMessage } from "../ui/Message";
import { KBD } from "../utils/Keybindings";
import { listen } from "../hooks/Listener";
import Status from "../ui/Status";
import { InfoIcon } from "../utils/Icons";
import InventoryDetails from "../components/InventoryDetails";
import Label from "../ui/Label";
import Divider from "../ui/Divider";
import Space from "../ui/Space";
import Card from "../ui/Card";
import { addISBNDashes, bm_date, combineObjects } from "../utils/Utils";

export default function TitleLinkData(props) {

    const { callback = () => { }, stock_data = {}, setStock = () => { }, route = "" } = props;

    const { primary_code = "" } = stock_data;
    const [data, setData] = useState({});

    const fetchTitle = () => {
        pubCall("title_link.search", { limit: 1, term: primary_code, type: "isbn", scope: "both", sort: "rank" }, (_s, _r) => {
            if (_s) {
                if (_r.rows.length > 0) {
                    setData(_r.rows[0]?.title_link || {});
                } else {
                    showError({error : "Title not found."});
                }
            } else {
                showError(_r.error)
            }
        })
    }
    useEffect(fetchTitle, [])



    useEffect(() => {
        const actions = [
            { key: KBD.ENTER, action: (e) => { callback(combineObjects({...stock_data}, {...data, 
                "note" : {...stock_data.note, "full_note" : (stock_data.note.full_note) ? stock_data.note.full_note : data.series}, 
                "category_1" : stock_data.category_1,
                "category_2" : stock_data.category_2, 
                "original_publisher" : data.publisher.toUpperCase().slice(0, 5)})) } },
            { key: KBD.ESCAPE, action: (e) => { callback() } },
        ];
        const cleanup = listen(route, actions, false);
        return cleanup;
    }, [data, stock_data]);


    const {
        title = "",
        author = "",
        author_2 = "",
        author_3 = "",
        series = "",
        subject = "",
        note = "",
        binding = "",
        binding_format = "",
        carton_quantity = "",
        publication_date = "",
        publisher = "",
        price_ca = null,
        price_us = null,
        data_source = "",
        updated = ""
    } = data;

    return (
        <>
            <InventoryDetails updateRow={() => { }} switchEdit={() => { }} edit={false} stock_data={stock_data} />
            <div className="shim" />
            <Card secondary style={{ "width": "1355px", "height": "calc(100vh - 390px)" }}>
                <div className="shim" />
                <Space height={25} size={10}>
                    <Label width={110}>Title</Label><Divider vertical />
                    <Label>{title}</Label>
                </Space>
                <div className="shim" />
                <Space height={25} size={10}>
                    <Label width={110}>Author(s)</Label><Divider vertical />
                    <Space size={0}>
                        <Label>{author}</Label>
                        {(author_2 && <Label>&nbsp; - &nbsp;{author_2}</Label>)}
                        {(author_3 && <Label>&nbsp; - &nbsp;{author_3}</Label>)}
                    </Space>
                </Space>
                <div className="shim" />
                <Space height={25} size={10}>
                    <Label width={110}>Series</Label><Divider vertical />
                    <Label>{series}</Label>
                </Space>
                <div className="shim" />
                <Space height={25} size={10}>
                    <Label width={110}>Subjects</Label><Divider vertical />
                    <Label>{subject}</Label>
                </Space>
                <div className="shim" />
                <Space height={25} size={10}>
                    <Label width={110}>Binding</Label><Divider vertical />
                    <Label>{binding} {binding_format}</Label>
                </Space>
                <div className="shim" />
                <Space height={25} size={10}>
                    <Label width={110}>Carton quantity</Label><Divider vertical />
                    <Label>{carton_quantity}</Label>
                </Space>
                <div className="shim" />
                <Space height={25} size={10}>
                    <Label width={110}>Pubdate</Label><Divider vertical />
                    <Label>{bm_date(publication_date)}</Label>
                </Space>
                <div className="shim" />
                <Space height={25} size={10}>
                    <Label width={110}>Publisher</Label><Divider vertical />
                    <Label>{publisher}</Label>
                </Space>
                <div className="shim" />
                <Space height={25} size={10}>
                    <Label width={110}>Price</Label><Divider vertical />
                    <Label>{(price_us && price_us/100 + "USD")} {(price_ca && price_ca/100 + "CAD")}</Label>
                </Space>
                <div className="shim" />
                <Space height={25} size={10}>
                    <Label width={110}>EAN</Label><Divider vertical />
                    <Label>{addISBNDashes(data.primary_code)}</Label>
                </Space>
                <div className="shim" />
                <Space height={25} size={10}>
                    <Label width={110}>Source</Label><Divider vertical />
                    <Label>{data_source}</Label>
                </Space>
                <div className="shim" />
                <Space height={25} size={10}>
                    <Label width={110}>Updated</Label><Divider vertical />
                    <Label>{bm_date(updated)}</Label>
                </Space>
            </Card>

            <div className="shim" />
            <Status><InfoIcon /> Press <strong>{KBD.ENTER.label}</strong> to insert this data. </Status>
        </>
    )
}